<template>

  <!-- <span class="typers-holder" v-if="this.typingOccurs">
      <span class="typers-text">{{ this.typersText }}</span>
    </span> -->

  <div class="tiblock" :title="this.typersText" v-if="this.typingOccurs">
    <div class="tidot"></div>
    <div class="tidot"></div>
    <div class="tidot"></div>
  </div>

</template>

<script lang="ts">

import { Component, Prop, Vue } from "vue-facing-decorator";
import { TypingCommunicatorData, TypingUserData } from "@/TickApi";

@Component({
  components: {},
})
export default class TypingIndicator extends Vue {
  @Prop({ default: [] }) private users!: TypingUserData[];
  @Prop({ default: [] }) private communicators!: TypingCommunicatorData[];

  private get typingOccurs(): boolean {
    return this?.filteredUsers.length > 0 || this?.communicators.length > 0;
  }

  private get filteredUsers() {
    return (this?.users || []);
  }

  private get filteredCommunicators() {
    return (this.communicators || []);
  }

  private get typersCount() {
    return (this?.filteredUsers.length + this?.communicators.length);
  }

  private get onlyOneTyper() {
    return (this.typersCount) == 1;
  }

  private get typersText() {
    if (this.onlyOneTyper && this.filteredUsers.length == 1 && this.filteredUsers[0].name) {
      return `${this.filteredUsers[0].name} is typing ...`;
    }

    return this.typersCount
      ? this.onlyOneTyper
        ? "someone is typing ..."
        : ` ${this.typersCount} persons are typing ...`
      : ""
  }

}
</script>

<style lang="scss" scoped>
@import "@/styles/theme";


.tiblock {
  align-items: center;
  display: flex;
  height: 17px;
  padding-left: 20px;
}

.tidot {
  background-color: #ffffff;
}

.tidot {
  -webkit-animation: mercuryTypingAnimation 1.5s infinite ease-in-out;
  border-radius: 2px;
  display: inline-block;
  height: 4px;
  margin-right: 2px;
  width: 4px;
}

@keyframes mercuryTypingAnimation {
  0% {
    -webkit-transform: translateY(0px)
  }

  28% {
    -webkit-transform: translateY(-5px)
  }

  44% {
    -webkit-transform: translateY(0px)
  }
}

.tidot:nth-child(1) {
  -webkit-animation-delay: 200ms;
}

.tidot:nth-child(2) {
  -webkit-animation-delay: 300ms;
}

.tidot:nth-child(3) {
  -webkit-animation-delay: 400ms;
}
</style>